import { ApiCallError } from 'app/http/ApiCallError';

const handledStatuses = new Set([401, 412, 418, 429, 500]);

export const shouldNotifySsoProvidersError = (error: unknown) =>
  !(error instanceof ApiCallError && error.status !== undefined && handledStatuses.has(error.status));
